// extracted by css-extract-rspack-plugin
export default {"wrapper":"_afa5b037","lastItem":"_a730be7b","item":"_20e77631"};